import { LayoutOptions } from '../../../interfaces/layout'
import { deepMerge } from '../../../utils/deepMerge'
import { ItemListProps } from './ItemList.types'

// general default props
const itemListDefault: Partial<ItemListProps> = {
  columns: 2,
  emptyMessage: {
    icon: 'MdOutlineInfo',
    message: 'There are no products to show'
  },
  errorMessage: {
    icon: 'MdOutlineErrorOutline',
    message: 'There was an error loading the data'
  },
  loadingMessage: {
    loader: true
  }
}

const itemListHorizontal = deepMerge(itemListDefault, {
  columns: 1
})

export const itemListLayout: Record<LayoutOptions, Partial<ItemListProps>> = {
  none: itemListHorizontal,
  default: itemListDefault,
  horizontal: itemListHorizontal,
  condensed: itemListHorizontal,
  recommended: itemListDefault,
  classic: itemListDefault,
  classicHorizontal: itemListHorizontal,
  message: itemListHorizontal,
  cart: itemListHorizontal,
  cartCondensed: itemListHorizontal,
  detail: itemListHorizontal,
  catalogCard: itemListDefault,
  horizontalCatalogCard: itemListHorizontal,
  detailFullPage: itemListHorizontal
}
